import { Button, Typography } from 'antd';
const { Text } = Typography;

const ShippingPrefsReadOnly: React.FC<{
  shippingAccountNumber?: string;
  carrier?: string;
  shippingMethod?: string;
  onEdit?: () => void;
  showEdit?: boolean;
  readOnly?: boolean;
}> = ({ shippingAccountNumber, carrier, shippingMethod, onEdit, showEdit, readOnly }) => {
  const canEdit = !!showEdit && !readOnly;

  const line = (label: string, value?: string) => (
    <div className="flex justify-between gap-4 text-sm">
      <span className="text-slate-500">{label}</span>
      <span className="text-slate-900 font-medium text-right">{value?.trim() ? value : '—'}</span>
    </div>
  );

  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50 px-3 py-2">
      <div className="flex items-center justify-between mb-1">
        <Text strong>Shipping Preferences</Text>
        {canEdit ? (
          <Button type="link" size="small" className="p-0 h-auto" onClick={onEdit}>
            Edit
          </Button>
        ) : null}
      </div>

      <div className="space-y-1">
        {line('Shipping account', shippingAccountNumber)}
        {line('Carrier', carrier)}
        {line('Method', shippingMethod)}
      </div>
    </div>
  );
};

export default ShippingPrefsReadOnly;